var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil",
    transform: "translate(0 -0.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67635",
    "data-name": "Path 67635",
    d: "M.588,12.472A2.007,2.007,0,0,0,0,13.891v1.03H1.03a2.007,2.007,0,0,0,1.419-.588l6.7-6.7L7.284,5.776Z",
    transform: "translate(0 -2.835)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67636",
    "data-name": "Path 67636",
    d: "M19.55.472a1.316,1.316,0,0,0-1.862,0l-1.759,1.76L17.79,4.093l1.76-1.759a1.316,1.316,0,0,0,0-1.862Z",
    transform: "translate(-7.936)",
    fill: "#202020"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit_pencil.fcaace4cf34909d7933629783c30e50c.svg";
export { ForwardRef as ReactComponent };